import { getQueryStringValue } from '@shared/utils';

export class TokenManager {
	private static authToken: string | null = null;

	static async init(): Promise<void> {
		try {
			const token = getQueryStringValue('token');

			if (!token) {
				throw new Error('Missing required query parameter: token');
			}

			this.authToken = token;
		} catch (error) {
			console.error('Error initializing TokenManager:', error);
			throw error;
		}
	}

	static getToken(): string {
		if (!this.authToken) {
			throw new Error('Token Absent');
		}
		return this.authToken;
	}
}
